/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/PerformanceIndicatorDataReport'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./PerformanceIndicatorDataReport'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.FinancialBatchPreviewReport = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.PerformanceIndicatorDataReport);
  }
}(this, function(ApiClient, PerformanceIndicatorDataReport) {
  'use strict';




  /**
   * The FinancialBatchPreviewReport model module.
   * @module model/FinancialBatchPreviewReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>FinancialBatchPreviewReport</code>.
   * @alias module:model/FinancialBatchPreviewReport
   * @class
   */
  var exports = function() {
    var _this = this;



  };

  /**
   * Constructs a <code>FinancialBatchPreviewReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/FinancialBatchPreviewReport} obj Optional instance to populate.
   * @return {module:model/FinancialBatchPreviewReport} The populated <code>FinancialBatchPreviewReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('Errors')) {
        obj['Errors'] = ApiClient.convertToType(data['Errors'], 'String');
      }
      if (data.hasOwnProperty('Results')) {
        obj['Results'] = ApiClient.convertToType(data['Results'], [PerformanceIndicatorDataReport]);
      }
    }
    return obj;
  }

  /**
   * @member {String} Errors
   * @default ''
   */
  exports.prototype['Errors'] = '';
  /**
   * @member {Array.<module:model/PerformanceIndicatorDataReport>} Results
   */
  exports.prototype['Results'] = undefined;



  return exports;
}));


